import { useEffect, useRef, useState } from "react";
import { useAuth } from "../contexts/authProvider";
import { getUserStatus } from "../services/presenceService";

import logger from 'utils/logger';
/**
 * Hook customizado para monitorar o status de presença de um usuário
 * @param {string} targetUserId - ID do usuário a ser monitorado
 * @returns {Object} - Objeto contendo state ('online' ou 'offline') e last_seen (timestamp)
 */
export const useUserStatus = (targetUserId) => {
  const [status, setStatus] = useState({
    state: "offline",
    last_seen: null,
  });
  const { user, loading } = useAuth();
  const unsubscribeRef = useRef(null);

  useEffect(() => {
    // Se ainda está carregando a autenticação ou não há targetUserId, não fazer nada
    if (loading || !targetUserId) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setStatus({ state: "offline", last_seen: null });
      return;
    }

    // Se não há usuário autenticado, não pode acessar os dados
    if (!user) {
      logger.warn("useUserStatus: usuário não autenticado");
       
      setStatus({ state: "offline", last_seen: null });
      return;
    }

    // Configurar listener para o status do usuário imediatamente
    unsubscribeRef.current = getUserStatus(targetUserId, (userStatus) => {
      setStatus(userStatus);
    });

    // Função de limpeza
    return () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
        unsubscribeRef.current = null;
      }
    };
  }, [targetUserId, user, loading]);

  return status;
};
